import React, { useEffect } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './progress.scss';
export default function ProgressCircle(props) {
  const { percentage, divStyle } = props;

  return (
    <div className={divStyle}>
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        strokeWidth={4}
        styles={{
          path: {
            // Path color
            stroke: '#FFF',
          },
          trail: {
            // Trail color
            stroke: 'rgba(255, 255, 255, 0.15)',
            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: 'butt',
            // Rotate the trail
            transform: 'rotate(0.25turn)',
            transformOrigin: 'center center',
          },
          // Customize the text
          text: {
            // Text color
            fill: '#FFF',
            // Text size
            fontSize: '16px',
          },
        }}
      />
    </div>
  );
}
